import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, ago } from './api';

/** Suggested discussions per account, with a score and why. Draft a reply, open it, or dismiss. attrs: state, onDrafted */
export default class SuggestionsTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.account = '';
    this.items = null;
    this.busy = {};
    this.instructions = {};
    this.load();
  }
  load() {
    return api('GET', '/opportunities' + (this.account ? '?account=' + this.account : '')).then(r => {
      this.items = r.opportunities || [];
      this.weights = r.weights;
    }).catch(() => this.items = []).finally(() => m.redraw());
  }
  run(key, p) {
    this.busy[key] = true;
    m.redraw();
    return p.catch(() => {}).finally(() => {
      this.busy[key] = false;
      m.redraw();
    });
  }
  name(id) {
    const a = (this.attrs.state.accounts || []).find(x => x.userId === id);
    return a ? a.displayName : '#' + id;
  }
  view() {
    return m("div", {
      className: "VEC-suggestions"
    }, m("div", {
      className: "VEC-row-head"
    }, m("p", {
      className: "VEC-help"
    }, "Recent open discussions that fit each account: interests, profession, place, past participation and preferred tags", this.weights ? ' (weights ' + [this.weights.topic, this.weights.profession, this.weights.geography, this.weights.participation, this.weights.preferences].join(' / ') + ')' : '', ". Topics an account avoids are left out."), m("div", {
      className: "VEC-actions"
    }, m("select", {
      className: "FormControl VEC-inline-select",
      value: this.account,
      onchange: e => {
        this.account = e.target.value;
        this.items = null;
        this.load();
      }
    }, m("option", {
      value: ""
    }, "All accounts"), (this.attrs.state.accounts || []).map(a => m("option", {
      value: a.userId
    }, a.displayName))), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-sync",
      loading: this.busy.refresh,
      onclick: () => this.run('refresh', api('POST', '/opportunities/refresh', {
        account: this.account || null
      }).then(r => {
        this.items = r.opportunities || [];
      }))
    }, "Find suggestions"))), !this.items ? m(LoadingIndicator, null) : this.items.length ? m("ul", {
      className: "VEC-list"
    }, this.items.map(o => m("li", {
      className: "VEC-account",
      key: o.id
    }, m("div", {
      className: "VEC-account-main"
    }, m("div", {
      className: "VEC-score",
      title: "Match score"
    }, o.score), m("div", {
      className: "VEC-account-text"
    }, m("a", {
      className: "VEC-sug-title",
      href: '/d/' + o.discussionId,
      target: "_blank",
      rel: "noopener"
    }, o.title), m("div", {
      className: "VEC-muted"
    }, "For ", m("strong", null, this.name(o.accountId)), " \xB7 ", o.replies, " replies \xB7 last activity ", ago(o.lastPostedAt), o.participated ? ' · already took part' : ''), m("div", {
      className: "VEC-muted"
    }, o.reasons.join(' · '))), m("div", {
      className: "VEC-account-actions"
    }, m("input", {
      className: "FormControl VEC-regen-input",
      value: this.instructions[o.id] || '',
      placeholder: "Angle (optional)",
      oninput: e => this.instructions[o.id] = e.target.value
    }), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-magic",
      loading: this.busy['d' + o.id],
      disabled: !this.attrs.state.aiReady,
      onclick: () => this.draft(o)
    }, "Draft a reply"), m(Button, {
      className: "Button",
      loading: this.busy['x' + o.id],
      onclick: () => this.run('x' + o.id, api('POST', '/opportunities/' + o.id + '/dismiss', {
        account: this.account || null
      }).then(r => this.items = r.opportunities || []))
    }, "Dismiss")))))) : m("p", {
      className: "VEC-empty"
    }, "No suggestions yet. Press \"Find suggestions\". Accounts need interests, a profession or a place for good matches."));
  }
  draft(o) {
    this.run('d' + o.id, api('POST', '/drafts', {
      account: o.accountId,
      kind: 'reply',
      generate: true,
      discussion: String(o.discussionId),
      instructions: this.instructions[o.id] || '',
      source: 'opportunity',
      sourceRef: o.id
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, 'Draft ready for review in Drafts.');
      this.items = this.items.filter(x => x.id !== o.id);
    }));
  }
}